exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-draggable {\n    min-width:300px;\n    right:0;\n    overflow:visible;\n}\n\n.dropdown-draggable li:hover {\n    background-color:transparent;\n}\n\n.dropdown-draggable .btn {\n    padding: 0.5rem 1rem;\n}\n\n.dropdown-draggable .form-group {\n   margin-top:0.5rem;\n}\n\n.dropdown-draggable-content {\n    background-color:#eee;\n    border-radius:4px;\n    margin:0.5rem;\n    padding:1rem;\n    border:1px solid #ccc;\n}\n\n.dropdown-draggable-content h6 {\n    margin-bottom:0.5rem;\n}\n\n.dropdown-draggable-content input,\n.dropdown-draggable-content a {\n\tfont-size:0.9rem;\n}\n\n.flex-header {\n    background-color:white;\n    padding:1rem;\n}\n\n.flex-content {\n    overflow:scroll;\n}\n\n.container-dropzone {\n    min-height:400px;\n}\n\n.flex-content .flex-item {\n    background-color:white;\n    margin:1rem;\n    padding:1rem;\n    border-radius:4px;\n}\n\n.btn-bar.float-right {\n    margin-bottom:1rem;        \n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/kanban/components/monday-tasks/monday-tasks.component.css
// module id = ../../../../../src/app/base/components/kanban/components/monday-tasks/monday-tasks.component.css
// module chunks = main